import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _times from 'lodash/times';
import _values from 'lodash/values';
import _isObject from 'lodash/isObject';

import { EMPTY_OBJECT, EMPTY_STRING } from '../constants';

const ALPHA_NUMERIC_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const parseJSON = (jsonString: any) => {
	let result = EMPTY_OBJECT;
	if (!jsonString) {
		return result;
	}
	try {
		result = JSON.parse(jsonString);
	} catch (err: any) {
		// do nothing
	}
	return result;
};

export const parseString = (jsonObject: any) => {
	let result = EMPTY_STRING;
	try {
		result = JSON.stringify(jsonObject);
	} catch (error: any) {
		// do nothing
	}
	return result;
};

export const generateRandomString = (strLength: any) => {
	let result = '';
	const charactersLength = ALPHA_NUMERIC_CHARACTERS.length;
	_times(strLength, () => {
		result += ALPHA_NUMERIC_CHARACTERS.charAt(Math.floor(Math.random() * charactersLength));
	});

	return result;
};

export const getClonedData = (rowData: any, formFields: any, formDefaults?: any) => {
	const clonedData: any = {};
	_forEach(_values(formFields), (field: string) => {
		clonedData[field] = _get(rowData, field);
	});

	return { ...clonedData, ...formDefaults };
};

export const isValidJson = (jsonString: string) => {
	try {
		const o = window.JSON.parse(jsonString);
		if (_isObject(o)) {
			return true;
		}
		// eslint-disable-next-line no-empty
	} catch (err: any) {}
	return false;
};
